import styles from '../styles/staging-indicator.module.css';

function StagingIndicator() {
  if (process.env.REACT_APP_IS_STAGING !== 'true') {
    return null;
  }

  return (
    <div className={styles.indicator} role="status">
      Staging environment
    </div>
  );
}

export default StagingIndicator;
